// extracted by mini-css-extract-plugin
export default {"greyLabel":"VKv8DBuhzt1pXbE5zqwy"};